// Module
var code = `<breadcrumbs></breadcrumbs>

<section id="risk-category-details" class="box">
  <sub-header header="\$ctrl.category.name || 'Create New'"></sub-header>

  <div class="tab-content">
    <form name="\$ctrl.form">
      <div class="form-section">
        <form-section form-title="'Category info:'">
          <form-section-field field-title="'Name:'">
            <input
              type="text"
              placeholder="Name"
              required
              ng-model="\$ctrl.category.name"
              ng-pattern="/^[0-9a-zA-Z_ .\\/-,]+\$/"
              ng-minlength="1"
              ng-maxlength="500"/>
          </form-section-field>
          <form-section-field field-title="'Customer types:'">
            <multiselect
              required
              ng-model="\$ctrl.category.customerTypes"
              items="\$ctrl.availableCustomerTypes"
              label-property="'label'"
              value-property="'value'"
              select-all-option="true"
            >
            </multiselect>
          </form-section-field>
          <div class="form-section-field">
            <div class="form-section-field-title">Weight percentage:</div>
            <div></div>
            <glue-container append="'%'">
              <input type="number"
                     ng-model="\$ctrl.category.weightPercentage"
                     disabled />
            </glue-container>
          </div>
          <form-section-field field-title="'Assign to:'">
            <select ng-model="\$ctrl.category.assignTo"
                    ng-change="\$ctrl.onAssignToChange()"
                    title="Assign to"
                    required
                    ng-options="option.value as option.label for option in \$ctrl.assignToOption">
            </select>
          </form-section-field>
          <form-section-field field-title="'Selector Type:'">
            <select ng-model="\$ctrl.category.selectorType"
                    ng-disabled="\$ctrl.category.assignTo === 'LINKED_CONDITIONS'"
                    title="Selector Type"
                    ng-required="\$ctrl.category.assignTo !== 'LINKED_CONDITIONS'"
                    ng-options="option.value as option.label for option in \$ctrl.selectionTypeOption">
            </select>
          </form-section-field>
          <form-section-field field-title="'File:'" ng-if="\$ctrl.category.assignTo === 'SUBSTITUTED_VALUE'">
            <div class="substituted-value-file">
              <div class="substituted-value-hint" ng-if="!\$ctrl.canUploadSubstitutedValues()">
                Substituted values can be uploaded once the category exists. Fill in the category info and click Create first.
              </div>
              <div class="file-upload">
                <file-upload ng-if="\$ctrl.canUploadSubstitutedValues()"
                             ng-model="\$ctrl.uploadedFiles"
                             validate-uploaded
                             max-files="1"
                             name="documentUpload"
                             validate="{pattern: '.xls,*.xlsx,*.csv'}"
                             show-file-name="true"
                             show-remarks="false"
                             allow-duplicates="true"
                             enable-webcam="false"
                >
                </file-upload>
                <button class="btn btn-info pull-right download-btn"
                        type="button"
                        ng-click="\$ctrl.downloadSampleExcelFile()">
                  Download sample EXCEL file
                </button>
                <button class="btn btn-info pull-right download-btn"
                        type="button"
                        ng-click="\$ctrl.downloadSampleCsvFile()">
                  Download sample CSV file
                </button>
                <button class="btn btn-primary pull-right"
                        type="button"
                        ng-if="\$ctrl.canUploadSubstitutedValues()"
                        ng-click="\$ctrl.uploadSubstitutedValues()">
                  Upload categories
                </button>
              </div>
            </div>
          </form-section-field>
        </form-section>
      </div>

      <div class="clearfix"></div>

      <div class="buttons">
        <button class="btn btn-warning"
                ng-click="\$ctrl.goBack()">
          Cancel
        </button>
        <button class="btn btn-primary"
              ng-if="!\$ctrl.category.id"
              command-access="CreateRiskCategory"
              ng-disabled="\$ctrl.isMainSaveDisabled()"
              ng-click="\$ctrl.upsertCategory('create', 'CreateRiskCategory')">
          Create
        </button>
      </div>

      <table class="table table-style table-hover risk-category-entry__table" ng-if="\$ctrl.category.id">
        <thead>
        <tr>
          <th class="no-column-header">No</th>
          <th class="th--description">Description</th>
          <th class="th--conditions" ng-if="\$ctrl.category.assignTo !== 'NONE'">Condition</th>
          <th>Weight</th>
          <th>Risk level</th>
          <th>Auto high risk</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr ng-repeat="entry in \$ctrl.category.entries track by \$index"
            ng-form
            name="\$ctrl['form_' + \$index]">
          <td>{{\$index + 1}}.</td>
          <td>
            <input type="text"
                   class="input--description"
                   required
                   ng-model="entry.description"/>
          </td>
          <td ng-if="\$ctrl.category.assignTo !== 'NONE'">
            <div class="conditions">
              <div class="btn-group">
                <button class="btn btn-default dropdown-toggle"
                        data-toggle="dropdown">
                  Add <span class="caret"></span>
                </button>
                <ul class="dropdown-menu">
                  <li ng-repeat="pd in \$ctrl.propertyDefinitions">
                    <a ng-click="\$ctrl.addCondition(entry, pd)">{{pd.label}}</a>
                  </li>
                </ul>
              </div>
              <div ng-repeat="pd in \$ctrl.propertyDefinitions">
                <amount-condition conditions="entry.conditions"
                                  property-definition="pd"
                                  property-definitions="\$ctrl.propertyDefinitions">
                </amount-condition>

                <number-condition conditions="entry.conditions"
                                  property-definition="pd"
                                  property-definitions="\$ctrl.propertyDefinitions">
                </number-condition>

                <dictionary-condition conditions="entry.conditions"
                                      property-definition="pd">
                </dictionary-condition>

                <substituted-value-condition conditions="entry.conditions"
                                  property-definition="pd">
                </substituted-value-condition>

                <single-select-condition conditions="entry.conditions"
                                         options="\$ctrl.singleSelectOptions.get(pd.property)"
                                         property-definition="pd">
                </single-select-condition>

                <double-select-condition conditions="entry.conditions"
                                         options1="\$ctrl.customFieldDefinitionCategories"
                                         options2="\$ctrl.customFieldCategories"
                                         property-definition="pd">
                </double-select-condition>

                <single-select-and-text-condition conditions="entry.conditions"
                                         options="\$ctrl.customFieldDefinitionTexts"
                                         property-definition="pd">
                </single-select-and-text-condition>

                <single-select-and-number-condition conditions="entry.conditions"
                                         options="\$ctrl.customFieldDefinitionNumbers"
                                         property-definition="pd">
                </single-select-and-number-condition>

                <boolean-condition conditions="entry.conditions"
                                   property-definition="pd">
                </boolean-condition>
              </div>
            </div>
          </td>
          <td>
            <input type="number"
                   class="input--small-number"
                   required
                   min="0"
                   ng-max="\$ctrl.maxIntegerValue"
                   step="1"
                   ng-model="entry.weight"/>
          </td>
          <td>
            <select
              class="select--risk-level"
              ng-model="entry.riskDictionaryEntryId"
              ng-options="de.id as de.description for de in \$ctrl.riskDictionaryEntries"
              ng-change="\$ctrl.onRiskLevelChange(entry)"
              required>
            </select>
          </td>
          <td>
            <input type="checkbox"
                 ng-disabled="\$ctrl.isAutoHighRiskDisabled(entry)"
                   ng-model="entry.autoHighRisk"/>
          </td>
          <td>
            <div class="buttons">
              <button type="button"
                      class="btn btn-danger"
                      command-access="UpsertRiskCategoryEntries"
                      ng-click="\$ctrl.removeEntry(\$index)">
                Delete
              </button>
            </div>
          </td>
        </tr>
        </tbody>
        <tfoot class="risk-category-entry__table--footer">
        <tr>
          <td colspan="{{ \$ctrl.category.assignTo === 'NONE' ? 5 : 6 }}">
          </td>
          <td>
            <div class="buttons">
              <button class="btn btn-success risk-categories-entry__button"
                      type="button"
                      command-access="CreateRiskCategoryEntry"
                      ng-disabled="\$ctrl.form.\$invalid || !\$ctrl.category.id || \$ctrl.category.assignTo === 'SUBSTITUTED_VALUE'"
                      ng-click="\$ctrl.addEntry()">
                Add new
              </button>
              <button class="btn btn-primary risk-categories-entry__button"
                      type="button"
                      command-access="CreateRiskCategoryEntry"
                      ng-disabled="\$ctrl.form.\$invalid"
                      ng-click="\$ctrl.saveAllEntries()">
                Save all
              </button>
            </div>
          </td>
        </tr>
        </tfoot>
      </table>
    </form>
  </div>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/compliance/risk-profiling/risk-categories/risk-category-details.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;